import GiftCards from 'components/GiftCards/GiftCards';
import { withGiftCardProps } from 'viewModel/richProfile/myAccount/payments/giftCards/withGiftCardProps';

export default withGiftCardProps(GiftCards);
